<template>
  <v-container fluid>
    <v-dialog
      v-model="mainDialgo"
      scrollable
      fullscreen
      max-width="500px"
      transition="dialog-transition"
    >
      <template v-slot:activator="{ attrs }">
        <!-- v-on="on" -->
        <v-btn
          small
          color="success"
          v-bind="attrs"
          :loading="isloading"
          @click="OpenTranDialog"
          icon
        >
          <v-icon>fas fa-info-circle</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="error white--text">
          {{ Title }} Transactions
          <v-spacer></v-spacer>
          <v-btn
            class="d-print-none"
            dark
            text
            icon
            @click="mainDialgo = false"
          >
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-card flat>
            <v-card-title>
              <!-- {{ TranInfo.FullName }} -->
              <v-spacer></v-spacer>
              <v-text-field
                outlined
                v-model="search"
                append-icon="fas fa-search"
                label="Search"
                single-line
                hide-details
                class="d-print-none"
              ></v-text-field>
              <v-btn
                v-if="Transactions.length"
                icon
                class="d-print-none"
                @click="PrintPage"
                small
                color="success"
              >
                <v-icon>fas fa-print</v-icon>
              </v-btn>
            </v-card-title>

            <v-data-table
              :headers="customHeader"
              :items="Transactions"
              :search="search"
              :items-per-page="itemPerPage"
              :hide-default-footer="isPrinting"
            >
              <template v-slot:top>
                <v-toolbar flat color="grey lighten-4">
                  <v-toolbar-title v-if="fromDate != '' && toDate != ''"
                    >{{ fromDate }} --- {{ toDate }}</v-toolbar-title
                  >

                  <v-divider class="mx-4" inset vertical></v-divider>
                  <!-- <div class="flex-grow-1"></div> -->
                  <searchDate
                    :searching="searching"
                    :SearchFun="OnSearch"
                  ></searchDate>
                  <v-spacer></v-spacer>
                  <div>
                    <DeptView
                      :Deptor="{
                        Description: TranInfo._id,
                        Name: TranInfo.Name,
                        Amount: AvailibleBalanceArray,
                      }"
                      :fullscreen="false"
                    >
                      <div class="mr-15">
                        <cashDisplay
                          colorName="teal"
                          :isloading="isloading"
                          :Balance="AvailibleBalanceArray"
                        ></cashDisplay>
                      </div>
                    </DeptView>
                  </div>
                </v-toolbar>
              </template>

              <template v-slot:[`item.Details`]="{ item }">
                <slot name="Details" :row="item">
                  {{ item.Details | filterCode }}
                </slot>
              </template>

              <template v-slot:[`item.deposit`]="{ item }">
                <slot name="deposit" :row="item">
                  <template v-if="item.Acc == 'Dr'">
                    {{ Math.abs(item.Amount).toLocaleString() }}
                    {{ item.AmountType | MoneySigns }}
                  </template>
                </slot>
              </template>
              <template v-slot:[`item.withdraw`]="{ item }">
                <slot name="withdraw" :row="item">
                  <template v-if="item.Acc == 'Cr'">
                    {{ Math.abs(item.Amount).toLocaleString() }}
                    {{ item.AmountType | MoneySigns }}
                  </template>
                </slot>
              </template>

              <template v-slot:[`item.Ref`]="{ item }">
                <slot name="Ref" :row="{ ...item, OnSearch, fromDate, toDate }">
                  {{ item.Ref }}
                </slot>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import cashDisplay from "@/components/util/displayCash.vue";
import searchDate from "@/components/util/searchDate.vue";
import axios from "axios";
import { Printd } from "printd";
import { printTable } from "@/Mixins/printTable";
// import { TableCSS } from "../Sales/princssModule";
// import { EventBus } from "@/main";
export default {
  mixins: [printTable],
  components: {
    cashDisplay,
    searchDate,
    DeptView: () => import("@/components/Branches/Deptors/DeptorList.vue"),
  },
  props: {
    TranInfo: { type: Object, required: true },
    Title: { type: String, required: true },
    BaseURL: { type: String, default: "/supplier" },
    headers: {
      type: Array,
      default: () => [
        {
          text: "Date",
          align: "left",
          value: "date",
        },
        { text: "Details", value: "Details" },
        { text: "Cash Type", value: "AmountType" },
        { text: "Deposit", value: "deposit" },
        { text: "Withdrawal", value: "withdraw", class: "blue--text" },
        { text: "User", value: "User" },
        { text: "Ref", value: "Ref" },
      ],
    },
  },
  data() {
    return {
      // BaseURL: "/supplier",
      mainDialgo: false,
      itemPerPage: 10,
      isloading: false,
      searching: false,
      search: "",
      fromDate: "",
      toDate: "",
      AvailibleBalanceArray: [],
      Transactions: [],
      EmptyMessage: "",
      dialog: false,
      isPrinting: false,
    };
  },
  computed: {
    customHeader() {
      if (this.isPrinting)
        return [
          { value: "index", text: "#" },
          ...this.headers.filter(header => header.text !== "Ref"),
        ];
      return this.headers;
    },
  },
  methods: {
    async PrintPage() {
      this.isPrinting = true;
      const d = new Printd();

      d.print(
        // document.getElementById("printContent"),
        this.PrintReport(this.Transactions, this.customHeader),
        [this.CustomStyle()],
        [],
        ({ launchPrint }) => {
          //   console.log(this.OrderPrint);
          launchPrint();

          this.isPrinting = false;
        }
      );
    },
    //     CustomStyle() {
    //       return `
    // .myContainer {
    //   font: 12pt serif, "Times New Roman", Times, Georgia;
    //   display: flex;
    //   flex-direction: column;
    //   padding: 10px 15px;
    //   height: 100%;
    //   background-color: white;
    // }
    // .printHearder {
    //   background-color: #ff5252;
    //   border-radius: 20px 20px 0 0;
    //   border-bottom: 3px solid rgba(0, 0, 0, 0.557);
    //   flex-wrap: wrap;
    //   /* width: 100%; */
    //   font-size: 1.5rem;
    //   color: black;
    //   padding: 15px 10px;
    //   display: flex;
    //   flex-direction: row;
    //   justify-content: center;
    // }
    // .my-table-content {
    //   border-collapse: collapse;
    //   background-color: white;

    // }
    // .my-table-Header {
    //   background-color: #ff5252;
    //   color: black;
    //   text-align: left;
    //   font-weight: bold;
    // }
    // .my-table-content > thead > tr > th {
    //   border-bottom: gray solid 1px;
    //   border-right: gray solid 1px;
    //   padding: 10px 15px;
    //   /* color: green; */
    // }
    // .my-table-content > tbody > tr > td {
    //   padding: 10px 15px;
    //   text-align: center;
    //   font-size: 14px;
    //   color: #202124;

    //   border-left: lightgrey solid 1px;
    //   border-right: lightgrey solid 1px;
    //   border-bottom: lightgrey solid 1px;
    // }

    // #myFooter {
    //   display: flex;
    //   flex-direction: row;
    //   justify-content: flex-end;
    //   font-weight: bold;
    //    font-size: 18px;
    //   color: #202124;

    //   border-bottom: 5px double;
    //   border-top: 4px solid brown;
    //   padding: 4px 8px;
    //   /* margin-bottom: 30rem; */
    //   /* bottom: 100px; */
    // }
    // `;
    //     },
    //     CreateText(txt) {
    //       const div = document.createElement("div");
    //       const textNode = document.createTextNode(txt);
    //       div.appendChild(textNode);
    //       return div;
    //     },
    //     PrintReport() {
    //       const container = document.createElement("div");
    //       container.className = "myContainer";
    //       const pageHeader = document.createElement("div");
    //       pageHeader.className = "printHearder";
    //       const txtHeader = `${this.Title.toUpperCase()} INVOICE`;

    //       pageHeader.appendChild(this.CreateText(txtHeader));
    //       container.appendChild(pageHeader);

    //       const table = document.createElement("table");
    //       table.className = "my-table-content";
    //       table.id = "my-table";
    //       let tableHeader = this.CreateTableHeader();
    //       table.appendChild(tableHeader);
    //       table.appendChild(this.CreateTableBody());

    //       container.appendChild(table);
    //       container.appendChild(this.CreateTableFooter());
    //       // const clear = document.createElement("div");
    //       // clear.id = "clearFix";
    //       // container.appendChild(clear);
    //       return container;
    //     },
    //     appendParent() {
    //       let page = document.getElementById("printContent");
    //       const first = page.firstChild;
    //       while (page.lastChild) {
    //         page.removeChild(page.lastChild);
    //       }
    //       page.appendChild(first);
    //       page.appendChild(this.PrintReport());
    //       // console.log(page);
    //     },

    //     CreateTableHeader() {
    //       const headFrg = document.createDocumentFragment();
    //       const thead = document.createElement("thead");
    //       thead.id = "my-table-Header";
    //       const tr = document.createElement("tr");
    //       this.customHeader.forEach(({ text }) => {
    //         let title = document.createTextNode(text);
    //         let th = document.createElement("th");
    //         th.className = "my-table-Header";
    //         th.appendChild(title);
    //         headFrg.appendChild(th);
    //       });
    //       tr.appendChild(headFrg);
    //       thead.appendChild(tr);
    //       return thead;
    //     },
    //     CreateTableBody() {
    //       const tbody = document.createElement("tbody");
    //       this.Transactions.forEach((row, index) => {
    //         let tr = document.createElement("tr");
    //         let colFrg = document.createDocumentFragment();
    //         // let tdIndex = document.createElement("td");
    //         // tdIndex.appendChild(document.createTextNode(index + 1));
    //         // colFrg.appendChild(tdIndex);
    //         row["index"] = index + 1;

    //         this.customHeader.forEach(({ value, text }) => {
    //           let content = document.createTextNode(row[value] || "");
    //           let Amount = row.Amount;
    //           // console.log(row);

    //           if (text === row.Acc)
    //             content = document.createTextNode(
    //               Math.abs(Amount).toLocaleString()
    //             );

    //           let td = document.createElement("td");
    //           td.appendChild(content);
    //           colFrg.appendChild(td);
    //         });

    //         tr.appendChild(colFrg);
    //         tbody.appendChild(tr);
    //       });
    //       // tbody.appendChild(tr);
    //       // console.log(tbody);
    //       return tbody;
    //     },

    //     CreateTableFooter() {
    //       // console.log(this.AvailibleBalanceArray);
    //       let [Total] = this.AvailibleBalanceArray;
    //       let { Amount, AmountType } = Total || { Amount: null, AmountType: null };
    //       let text = `${Amount && Amount.toLocaleString()} ${AmountType}`;
    //       let content = document.createTextNode(text);

    //       const FooterDiv = document.createElement("div");
    //       FooterDiv.id = "myFooter";
    //       const footerContent = document.createElement("div");
    //       footerContent.appendChild(content);
    //       FooterDiv.appendChild(footerContent);

    //       return FooterDiv;
    //     },

    OpenTranDialog() {
      this.Transactions = [];

      this.AvailibleBalanceArray = [];

      this.searching = true;
      this.isloading = true;

      this.MultReq()
        .then(result => {
          //   console.log(result[0]);
          this.mainDialgo = true;
          this.isloading = false;
          this.Transactions = result[0].data;

          this.AvailibleBalanceArray = result[1].data;

          this.searching = false;
          this.$nextTick(() => {
            // this.appendParent();
          });
        })
        .catch(() => {
          this.isloading = false;
          // console.log(error);
          this.searching = false;
        });
    },

    AvailibleBalance() {
      return this.$store.dispatch("FIND_BY_VALUE", {
        url: `${this.BaseURL}/balance`,
        query: {
          _id: this.TranInfo._id,
        },
      });
    },
    TranSactionsCall() {
      return this.$store.dispatch("FIND_BY_VALUE", {
        url: `${this.BaseURL}/transactions`,
        query: {
          _id: this.TranInfo._id,
          from: this.fromDate,
          to: this.toDate,
        },
      });
    },
    MultReq() {
      return axios.all([this.TranSactionsCall(), this.AvailibleBalance()]);
    },
    close() {
      this.dialog = false;
    },
    OnSearch(from, to) {
      //   if (this.$refs.form.validate()) {
      this.fromDate = from;
      this.toDate = to;

      this.Transactions = [];

      this.AvailibleBalanceArray = [];

      this.searching = true;
      this.isloading = true;
      this.$store;
      this.MultReq()
        .then(result => {
          // console.log(result[0]);
          this.isloading = false;
          this.Transactions = result[0].data;

          this.AvailibleBalanceArray = result[1].data;

          this.searching = false;
        })
        .catch(() => {
          this.isloading = false;
          // console.log(error);
          this.searching = false;
        });
    },
  },
  created() {
    // this.LoadCustomerData();
  },
};
</script>
<style>
.myContainer {
  font: 12pt serif, "Times New Roman", Times, Georgia;
  display: flex;
  flex-direction: column;
  padding: 10px 15px;
  height: 100%;
  background-color: white;
}

.printHearder {
  background-color: #ff5252;
  border-radius: 20px 20px 0 0;
  border-bottom: 3px solid rgba(0, 0, 0, 0.557);
  flex-wrap: wrap;

  /* width: 100%; */
  font-size: 1.5rem;
  color: black;
  padding: 15px 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.my-table-content {
  border-collapse: collapse;
  background-color: white;

  /* width: 100%; */
}
#my-table {
  page-break-inside: avoid;
}
#my-table > tbody > tr {
  page-break-inside: avoid;
  page-break-after: always;
}
#my-table-Header {
  display: table-header-group;
}
.my-table-Header {
  background-color: #ff5252;
  color: black;
  text-align: left;
  font-weight: bold;
}

.my-table-content > thead > tr > th {
  border-bottom: gray solid 1px;
  border-right: gray solid 1px;
  padding: 10px 15px;
  /* color: green; */
}
.my-table-content > tbody > tr > td {
  padding: 10px 15px;
  text-align: center;
  font-size: 14px;
  color: #202124;

  border-left: lightgrey solid 1px;
  border-right: lightgrey solid 1px;
  border-bottom: lightgrey solid 1px;
}

#myFooter {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  font-size: 18px;
  font-weight: bold;
  color: #202124;
  text-decoration: underline;
  border-bottom: 5px double;
  border-top: 4px solid brown;
  padding: 4px 8px;

  /* margin-bottom: 30rem; */
  /* bottom: 100px; */
}
#clearFix {
  height: 20px;
  width: 100%;
  /* background-color: coral; */
}
</style>
